import { render, staticRenderFns } from "./ImagesDropper.vue?vue&type=template&id=5cd7567e&"
import script from "./ImagesDropper.vue?vue&type=script&lang=js&"
export * from "./ImagesDropper.vue?vue&type=script&lang=js&"
import style0 from "./ImagesDropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports